var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"notification","title":_vm.iTitle,"centered":"","ok-only":""},on:{"ok":_vm.onOkayHandler,"hidden":_vm.onOkayHandler},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',[_vm._v(_vm._s(_vm.iText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }